import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { configure } from 'mobx';

import './styles.css';
import App from './components/app.component';
import * as serviceWorker from './serviceWorker';
import { initLogger } from './services/logger.service';
import environmentService from './services/environment.service';


configure({ enforceActions: 'observed' });

environmentService.checkApiOverride();
initLogger();

createRoot(document.getElementById('root') as HTMLElement).render((
  <BrowserRouter>
    <App />
  </BrowserRouter>
));

serviceWorker.unregister();
// serviceWorker.register({
//   onUpdate: registration => {
//     // alert('New version available!  Ready to update?');
//     if (registration && registration.waiting) {
//       registration.waiting.postMessage({ type: 'SKIP_WAITING' });
//     }
//     window.location.reload();
//   }
// });